const TEAM_OVERVIEW_COMPONENTS = {
    view_staff_list: {
        permissions: [{ permission_code: "TVR_VIEW_BORROWER" }],
    },
    view_applications_list: {
        permissions: [{ permission_code: "TVR_VIEW_BUSINESS_REFERENCE" }],
    },
    view_kpi_cards: {
        permissions: [{ permission_code: "TVR_VIEW_BUSINESS_REFERENCE" }],
    },
    view_applications_filter: {
        permissions: [{ permission_code: "VIEW_TEAM_APPLICATION_FILTERS" }]
    }
}

module.exports = {  
    TEAM_OVERVIEW_COMPONENTS,
}